export const CORE_MANAGEMENT_ROLES = Object.freeze([
  'kurucu',
  'ogrenci_isleri',
  'rehber_ogretmen',
  'muhasebe',
]);

export const ADMIN_PANEL_ROLES = Object.freeze(['kurucu', 'ogrenci_isleri']);

export const CORE_USER_MODULE_ROLES = Object.freeze(['ogretmen', 'veli']);

export const hasCoreManagementAccess = (role) => CORE_MANAGEMENT_ROLES.includes(role);

export const canManageScopedUsers = (role, targetRole) => {
  if (role === 'kurucu' || role === 'ogrenci_isleri') return true;
  return ['rehber_ogretmen', 'muhasebe'].includes(role)
    && CORE_USER_MODULE_ROLES.includes(targetRole);
};

export const getCoreManagementBasePath = (role) => {
  if (role === 'rehber_ogretmen') return '/rehber';
  if (role === 'muhasebe') return '/muhasebe';
  return '/admin';
};

const CORE_MANAGEMENT_MENU_DEFINITIONS = Object.freeze([
  { key: 'ogrenciler', icon: '◉', label: 'Öğrenciler' },
  { key: 'ogretmenler', icon: '◎', label: 'Öğretmenler' },
  { key: 'veliler', icon: '◍', label: 'Veliler' },
  { key: 'siniflar', icon: '▤', label: 'Sınıflar' },
]);

export const getCoreManagementMenuItems = (role) => {
  if (!hasCoreManagementAccess(role)) return [];
  const basePath = getCoreManagementBasePath(role);
  return CORE_MANAGEMENT_MENU_DEFINITIONS.map(item => ({
    path: `${basePath}/${item.key}`,
    icon: item.icon,
    label: item.label,
  }));
};
